var swedishLanguage = {
    AUTH_INVALID: "Någonting gick fel. Vi kunde inte hitta din profil. Vänligen försök igen.",
    ACCT_INACCESSIBLE: "Vi kan inte nå ditt Click to Pay konto. Vänligen försök igen vid ett senare tillfälle.",
    FRAUD: "Ditt Click to Pay konto är låst eller inaktiverat. Vänligen kontakta er kortleverantör.",
    OTP_SEND_FAILED: "Det gick inte att skicka koden.",
    OTP_SEND_FAILED_RESEND: "Klicka här för att skicka den igen.",
    RETRIES_EXCEEDED: "För mång försök. Vänligen vänta några minuter och försök igen.",
    SESSION_ID_INVALID: "Kunde inte nå tjänsten. Vänligen försök igen.",
    VALDATA_MISSING: "Vi kunde inte nå tjänsten. Vänligen försök igen vid ett senare tillfälle.",
    CODE_INVALID: "Ogiltig kod. Vänligen försök igen.",
    CODE_EXPIRED: "Koden har utgått.",
    CODE_EXPIRED_SEND: "Skicka en ny kod.",
    CARD_MISSING: "Vi misslyckades med att lägga till ditt kort. Vänligen försök igen.",
    CARD_ADD_FAILED: "Vi misslyckades med att lägga till ditt kort. Vänligen försök igen.",
    CARD_SECURITY_CODE_MISSING: "Vänligen ange en säkerhetskod.",
    CARD_INVALID: "Vänligen ange ett giltigt kortnummer.",
    CARD_EXP_INVALID: "Vänligen ange ett giltigt utgångsdatum för kortet.",
    CARD_NOT_RECOGNIZED: "Kortugivaren stöds inte för tillfället alternativt så är kortnummret ogiltigt. Vänligen försök med ett annat kort, eller kontrollera att kortnummret är korrekt.",
    MERCHANT_DATA_INVALID: "Tjänsten är för närvarande otillgänglig, betalningen kunde inte bearbetas. Vänligen försök igen vid ett senare tillfälle.",
    UNABLE_TO_CONNECT: "Tjänsten är för närvarande otillgänglig, betalningen kunde inte bearbetas. Vänligen försök igen vid ett senare tillfälle.",
    NO_INTERNET_CONNECTION: "Ingen internetanslutning. Kontrollera anslutningen och försök igen.",
    PROFILE_LOAD_FAILED: "Någonting gick fel. Uppdatera sidan och försök igen.",
    TERMS_AND_CONDITIONS_NOT_ACCEPTED: "Vänligen godta Click to Pays avtal.",
    SWW: "Någonting gick fel. Försök igen.",
    EMAIL_NOT_DEFINED: "E\u2011post adressen är inte angiven.",
    EMAIL_INVALID: "E\u2011post adressen är ogiltig.",
    OTP_EMPTY: "Aktiveringskoden får inte vara tom.",
    OTP_RESENT: "Aktiveringskoden har skickats på nytt.",
    EMPTY_PROFILE_LIST: "Inget konto hittades för den här e\u2011post adressen. Vänligen kontrollera din e\u2011post adress, eller skapa ett nytt konto.",
    EMPTY_CARD_LIST_HEADER: "Det ser ut som att du har ett Click to Pay konto. Vänligen lägg till ett kort.",
};
export default swedishLanguage;
